export const LOGIN = "LOGIN";
export const AUTO_SIGNIN = "AUTO_SIGNIN";
export const LOGOUT = "LOGOUT";
export const FORGOT_PASSWORD = "FORGOT_PASSWORD";
export const CHOOSE_HOSPITAL = "CHOOSE_HOSPITAL";

export const TESTS = "TESTS";
export const ALL_TESTS = "ALL_TESTS";
export const SEARCH_TESTS = "SEARCH_TESTS";
export const ONGOING_TESTS = "ONGOING_TESTS";
export const CURRENT_TEST = "CURRENT_TEST";
export const UPDATE_TEST = "UPDATE_TEST";
export const MCP_CARDS = "MCP_CARDS";
export const CURRENT_MCP_CARD = "CURRENT_MCP_CARD";
export const REALTIME_TESTS = "REALTIME_TESTS";

export const DOWNLOAD_REPORT = "DOWNLOAD_REPORT";
export const EMAIL_REPORT = "EMAIL_REPORT";
export const CHILD_PHOTO = "CHILD_PHOTO";
export const CHECK_REPORT_AVAILABILITY = "CHECK_REPORT_AVAILABILITY";

export const ANNOTATIONS = 'ANNOTATIONS';

export const SET_NAV_PATH = "SET_NAV_PATH";

export const SET_LANG = "SET_LANG";

export const SET_FHR_MHR = "SET_FHR_MHR";
export const SET_ANNOTATIONS_MODE = "SET_ANNOTATIONS_MODE";

export const USERS = 'USERS';
export const ADD_USER = 'ADD_USER';

export const TEST_TIMER = 'TEST_TIMER';
export const TEST_STOPPED = 'TEST_STOPPED';

export const REALTIME_CHAT_MESSAGES = 'REALTIME_CHAT_MESSAGES';
export const ALL_REALTIME_CHAT_MESSAGES = 'ALL_REALTIME_CHAT_MESSAGES';
export const SEND_REALTIME_CHAT_MESSAGE = 'SEND_REALTIME_CHAT_MESSAGE';
export const ACCOUNT_DETAILS = 'ACCOUNT_DETAILS';

export const HD_LOGIN = 'HD_LOGIN';
export const SEND_OTP = 'SEND_OTP';
export const VERIFY_OTP = 'VERIFY_OTP';
export const COMPLETE_REGISTRATION = 'COMPLETE_REGISTRATION';
export const COMPLETE_INVITE = 'COMPLETE_INVITE';
export const REQUEST_PASSWORD_RESET = 'REQUEST_PASSWORD_RESET';
export const RESET_PASSWORD = 'RESET_PASSWORD';